<template>
  <ExpansionPanel ref="expansionPanel">
    <template #header="{ toggleCollapse }">
      <div class="flex items-center justify-between gap-2 w-full">
        <div class="flex items-center gap-2 w-full">
          <div class="relative">
            <input
              type="color"
              :value="variant.color"
              class="absolute inset-1 w-6 h-6 opacity-0 cursor-pointer"
              @input="onColorInput"
              @click.stop
            />
            <div
              :style="{
                backgroundColor: lightenColor(variant.color),
                border: `2px solid ${variant.color}`,
              }"
              class="w-6 h-6 rounded-md cursor-pointer"
            ></div>
          </div>
          <button
            @click="toggleCollapse"
            class="font-semibold w-full text-left py-4"
          >
            {{ variant.name }}
          </button>
        </div>
        <button
          @click.stop="emit('delete', variant.id)"
          class="flex items-center justify-center text-red-500 hover:text-red-700 transition-colors duration-200"
        >
          <span class="material-symbols-outlined">delete</span>
        </button>
      </div>
    </template>

    <div class="px-6 py-4 border-b border-mid-neutral-50 space-y-4">
      <TextInput
        v-model="variant.name"
        label="Name"
        placeholder="Variant name"
        :is-required="true"
        :info-tooltip-text="'Provide variant name'"
        ref="nameInput"
      />
    </div>
  </ExpansionPanel>
</template>

<script setup lang="ts">
import { TextInput, ExpansionPanel } from "ui-components";
import { useTemplateRef, watch } from "vue";
import { type Variant } from "states/variants";
import { useVariants } from "./useVariants";
import { lightenColor } from "utils";
const expansionPanel = useTemplateRef("expansionPanel");
const emit = defineEmits<{ delete: [id: string] }>();
const nameInput = useTemplateRef("nameInput");
const variant = defineModel<Variant>({
  default: { id: "", name: "", color: "" },
});
const { updateColor, updateName } = useVariants();

function onColorInput(event: Event) {
  const target = event.target as HTMLInputElement;
  updateColor(variant.value.id, target.value);
}

watch(
  () => variant.value.name,
  (newName) => {
    updateName(variant.value.id, newName);
  }
);

function select() {
  nameInput.value?.select();
}
function scrollIntoView() {
  expansionPanel.value?.scrollIntoView();
}

defineExpose({ select, scrollIntoView });
</script>
